import StandartAppConfig from './standart/DataAppConfig';
import DynamicAppConfig from './dynamic/DataAppConfig';

const ExpendituresAppConfig = [StandartAppConfig, DynamicAppConfig];

export default ExpendituresAppConfig;
